import { render, staticRenderFns } from "./RepeatButton.vue?vue&type=template&id=1f65f798&scoped=true"
import script from "./RepeatButton.vue?vue&type=script&lang=ts"
export * from "./RepeatButton.vue?vue&type=script&lang=ts"
import style0 from "./RepeatButton.vue?vue&type=style&index=0&id=1f65f798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65f798",
  null
  
)

export default component.exports